import React from 'react';
import { HeadingWithBody, TileSelect } from '@99designs/spa-common';
import { svgBase64ToAscii } from '../../utils/svgBase64ToAscii';
import { STEP_PROMOTION } from '../constants';
import giftIcon from './Icons/gift-icon.svg';
import screenGiftIcon from './Icons/screen-gift-icon.svg';
import screenIcon from './Icons/screen-icon.svg';
import type { StepComponentProps } from '../../components/Onboarder/Config';
import type { SelectedValues } from '../config';

export type PromotionValue = 'online' | 'offline' | 'both';

export function PromotionStepInputs({ data, onChange }: StepComponentProps<SelectedValues>) {
    return (
        <TileSelect<PromotionValue>
            name={STEP_PROMOTION}
            value={data.promotion}
            options={[
                {
                    label: (
                        <HeadingWithBody
                            heading={__('Primarily Online')}
                            body={__('Website, social media, facebook ads, online promotions etc')}
                        />
                    ),
                    value: 'online',
                    icon: svgBase64ToAscii(screenIcon),
                },
                {
                    label: (
                        <HeadingWithBody
                            heading={__('Primarily Offline')}
                            body={__(
                                'Signage, posters, flyers, newspaper, magazine, trade shows etc'
                            )}
                        />
                    ),
                    value: 'offline',
                    icon: svgBase64ToAscii(giftIcon),
                },
                {
                    label: (
                        <HeadingWithBody
                            heading={__('Both')}
                            body={__('A combination of both online and offline')}
                        />
                    ),
                    value: 'both',
                    icon: svgBase64ToAscii(screenGiftIcon),
                },
            ]}
            onChange={(value, name) => {
                const newData: SelectedValues = {
                    ...data,
                    [name]: value,
                };
                onChange(newData);
            }}
        />
    );
}
